import { observableEvent } from '../_utils/observable-event';
import { GoogleAnalytics } from '../_libs/analytics/google-analytics';

export default class UploadAnalytics {
  static eventTypes(uploadAnalyticsArray) {
    const uploadRaw = 0,
      uploadBeamr = 1,
      uploadFellback = -1,
      // the values of the above don't matter, it's just for the input and output to be comparable
      uploads = uploadAnalyticsArray.map(a =>
        a.eventType(uploadRaw, uploadBeamr, uploadFellback)
      ),
      tally = uploads.reduce(
        (tally, event) => {
          if (event == uploadRaw) {
            tally['raw']++;
          }
          if (event == uploadBeamr) {
            tally['beamr']++;
          }
          if (event == uploadFellback) {
            tally['fellback']++;
            tally['raw']++;
          }

          return tally;
        },
        {
          raw: 0,
          beamr: 0,
          fellback: 0,
        }
      );

    if (tally.fellback > 0) {
      return `failover beamr: ${tally.beamr} raw: ${tally.raw}`;
    } else if (tally.beamr > 0) {
      return 'beamr';
    } else {
      return 'raw';
    }
  }

  constructor({
    fileName = null,
    uploadTransactionId = null,
    uploadTimings = {},
    fileUploadSource,
    beamrAbTestingGroup,
  }) {
    this._transactionId = uploadTransactionId;
    this._timings = uploadTimings;

    this._fileName = fileName;
    this.fileUploadSource = fileUploadSource;
    this._fileData = {
      originalSize: null,
      compressedSize: null,
    };

    this._googleAnalytics = new GoogleAnalytics();
    this.beamrAbTestingGroup = beamrAbTestingGroup;
  }

  eventType(raw = 'raw', beamr = 'beamr', fallback = 'fallback-to-raw') {
    return this.uploadFellOver()
      ? fallback
      : this.uploadedViaBeamr()
      ? beamr
      : raw;
  }

  setFileSizes(originalSize = null, compressedSize = null) {
    let changed = false;

    if (typeof originalSize !== null) {
      this._fileData.originalSize = originalSize;
      changed = true;
    }

    if (typeof compressedSize !== null) {
      this._fileData.compressedSize = compressedSize;
      changed = true;
    }

    return changed;
  }

  sendObservability() {
    observableEvent.record('photo-upload-beamr-success', {
      compr_elapsed_time_ms: this._timings.compressionDuration(),
      total_elapsed_time_ms: this._timings.completeDuration(),
      original_size: this._fileData.originalSize,
      optimized_size: this._fileData.compressedSize,
      upload_source: this.eventType(),
      num_threads: window.navigator.hardwareConcurrency,
    });
  }

  sendToGoogleAnalytics() {
    if (!this._googleAnalytics.analyticsEnabled()) {
      return undefined;
    }

    const beamrUploadSource = this.eventType('raw', 'beamr', 'beamr');

    console.debug(this._fileName, 'Sending to Google Analytics:', {
      transaction_id: this._transactionId,
      beamr_upload_source: beamrUploadSource,
      file_upload_source: this.fileUploadSource,
      compression_duration: this._timings.compressionDuration() || 0,
      complete_duration: this._timings.completeDuration(),
      original_size: this._fileData.originalSize,
      compressed_size:
        this._fileData.compressedSize || this._fileData.originalSize,
      beamr_ab_testing_group: this.beamrAbTestingGroup || 'disabled',
    });

    this._googleAnalytics.sendEvent('Print-Upload', {
      transaction_id: this._transactionId,
      beamr_upload_source: beamrUploadSource,
      file_upload_source: this.fileUploadSource,
      compression_duration: this._timings.compressionDuration() || 0,
      complete_duration: this._timings.completeDuration(),
      original_size: this._fileData.originalSize,
      compressed_size:
        this._fileData.compressedSize || this._fileData.originalSize,
      beamr_ab_testing_group: this.beamrAbTestingGroup || 'disabled',
    });

    return true;
  }

  // private

  uploadedViaBeamr() {
    return !!this._timings.compression;
  }

  uploadFellOver() {
    return !!this._timings.fallback;
  }
}
